import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

import { makeStyles } from "@mui/styles";

import Typography from "@mui/material/Typography";

import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";

import Button from "@mui/material/Button";

import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import API from "util/API";
import { showErrorSnackbar } from "store/actions/snackbarMessage";
import { useDispatch } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";

import { transformOrderId } from "util/orderUtils";
import AppIntroduction from "views/Checkout/AppIntroduction";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "100vh",
    backgroundColor: "#f9fafb",
  },
  spacer: {
    flexGrow: 1,
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(4, 2),
    maxWidth: 480,
    margin: "0 auto",
  },
  successIcon: {
    fontSize: 72,
    color: "#4caf50",
    marginBottom: theme.spacing(1),
  },
  orderRef: {
    backgroundColor: "#e8f5e9",
    borderRadius: 8,
    padding: theme.spacing(1, 3),
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(1),
  },
  uiProgess: {
    position: "fixed",
    zIndex: "1000",
    height: "31px",
    width: "31px",
    left: "50%",
    top: "35%",
  },
}));

export default function OrderSuccess(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const id = props.match.params.menuId;
  const tableId = props.match.params.tableId;
  const type = props.match.params.type;
  const [checkAdyenPayment, setCheckAdyenPayment] = useState(false);


  const showError = (msg) => dispatch(showErrorSnackbar(msg));
  const reference = () => {
    return transformOrderId(props.match.params.reference);
  };

  const getUrlParam = (key) => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(key);
  };

  const viewOrder = () => {
    history.push(`/orderSuccessDetail/${id}/${tableId}/${reference()}`);
  };

  const imageName = () => {
    return type
      ? "/static/images/successUnpaid.png"
      : "/static/images/success_promo.png";
  };

  useEffect(() => {
    if (window && window.parent) {
      const redirectResultType = getUrlParam("type");
      if (redirectResultType === "success") {
        window.parent.postMessage(
          { type: "payment_success", success: true },
          "*"
        );
      }
    }
  }, [props]);


  const handleSuccessResult = () => {
    console.log("Payment completed");
    const orderNumber = props.match.params.reference;


    // emptyOrderCart({ ...order.adyenSession.order.order, id: orderNumber });
  };

  const updateAdyenPaymentDetails = async (redirectResult) => {
    try {
      const result = await API.post(`adyenPaymentDetails`, {
        payload: {
          details: { redirectResult },
        },
      });
      setCheckAdyenPayment(false);
      if (result && result.data && result.data.resultCode === "Authorised") {
        handleSuccessResult();
      } else {
        showError("Payment failed, please try again.");
        history.push("/online/" + id + "/" + tableId);
      }
    } catch (error) {
      showError("Payment failed, please try again.");
      history.push("/online/" + id + "/" + tableId);
    }
  };

  useEffect(() => {
    // check url params inlcude  redirectResult
    const redirectResult = getUrlParam("redirectResult");
    if (redirectResult) {
      setCheckAdyenPayment(true);
      updateAdyenPaymentDetails(redirectResult);
    }
  }, [props]);

  if (checkAdyenPayment === true) {
    return (
      <div className={classes.root}>
        <CircularProgress size={150} className={classes.uiProgess} />
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <AppBar position="static" color="primary" elevation={1}>
        <Toolbar>
          <Typography color="inherit">{`Order #${reference()}`}</Typography>
          <span className={classes.spacer} />
          <Button color="inherit" variant="outlined" size="small" onClick={viewOrder}
            sx={{ borderColor: "rgba(255,255,255,0.5)", textTransform: "none" }}>
            View Order
          </Button>
        </Toolbar>
      </AppBar>

      <Box className={classes.content}>
        <CheckCircleOutlineIcon className={classes.successIcon} />

        <Typography variant="h5" align="center" sx={{ fontWeight: 700, color: "#1a1a1a" }}>
          Order Confirmed
        </Typography>

        <Box className={classes.orderRef}>
          <Typography variant="body2" align="center" sx={{ fontWeight: 600, color: "#2e7d32" }}>
            Order #{reference()}
          </Typography>
        </Box>

        <Typography variant="h6" align="center" sx={{ fontWeight: 600, color: "#1a1a1a", lineHeight: 1.5, mt: 1, mb: 3 }}>
          Thank you for your order! It has been successfully received and is being processed.
        </Typography>

        <AppIntroduction />
      </Box>
    </div>
  );
}
